import styled from 'styled-components/macro'

const SectionBadge = styled.div`
  height: 8px;
  position: static;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`

export default SectionBadge
